<template>
  <a-modal
      :visible="show"
      title="Utwórz zgłoszenie dla tego konta"
      :footer="null"
  >
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
          <a-form :form="form">
            <a-form-item label="Tytuł" :label-col="{span: 6}" :wrapper-col="{span: 14}">
              <a-input v-model="form.title" placeholder="Tytuł zgłoszenia"/>
            </a-form-item>
            <a-form-item label="Opis" :label-col="{span: 6}" :wrapper-col="{span: 14}">
              <a-textarea v-model="form.description" placeholder="Opis zgłoszenia" :autosize="{minRows: 3, maxRows: 5}" :disabled="submitting"/>
            </a-form-item>
            <a-form-item label="Lokalizacja" :label-col="{span: 6}" :wrapper-col="{span: 14}">
              <a-select v-model="form.dorm" placeholder="Wybierz lokalizację" :disabled="submitting">
                <a-select-option v-for="dorm in dorms" :key="dorm.code" :value="dorm.code">{{ dorm.name }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Pokój" :label-col="{span: 6}" :wrapper-col="{span: 14}">
              <a-input v-model="form.room" placeholder="Numer pokoju" :disabled="submitting"/>
            </a-form-item>
            <a-form-item :wrapper-col="{span: 14, offset: 6}">
              <a-button @click="close" :loading="submitting" style="margin-right: 1em">Anuluj</a-button>
              <a-button type="primary" @click="addIssue" :loading="submitting">Dodaj zgłoszenie</a-button>
            </a-form-item>
          </a-form>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import httpClient from "@/utils/httpClient";

export default {
  name: "CreateIssue",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    accountUuid: {
      type: String,
      default: ''
    },
    userDormCode: {
      type: String,
      default: ''
    },
    userRoom: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dorms: [],
      loadingEvents: true,
      form: {
        dorm: null,
        title: null,
        description: null,
        room: null
      },
      submitting: false
    }
  },
  mounted() {
    this.loadDorms()
  },
  methods: {

    loadDorms() {
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
            this.form.dorm = this.userDormCode;
            this.form.room = this.userRoom;
            this.loadingEvents = false;
          }).catch((error) => {
            if (error.response.status !== 401) {
              this.$message.error("Wystąpił błąd z pobraniem listy lokalizacji!")
            }
      })
    },

    addIssue() {
      if (!this.form.dorm || !this.form.title || !this.form.description || !this.form.room) {
        this.$message.warning("Wypełnij wszystkie pola formularza!")
        return;
      }

      this.submitting = true;
      httpClient
          .post(`/admin/issues`, {
            dorm: this.form.dorm,
            title: this.form.title,
            description: this.form.description,
            room: this.form.room,
            accountUuid: this.accountUuid
          })
          .then(() => {
            this.$message.success("Zgłoszenie zostało utworzone!")
            this.form = {
              dorm: null,
              title: null,
              description: null,
              room: null,
            }
            this.close()
          }).catch((error) => {
            if (error.response.status !== 401) {
              this.$message.error("Wystąpił błąd z dodaniem zgłoszenia!")
            }
      }).finally(() => {
        this.submitting = false;
      })
    },

    close() {
      this.$emit('close');
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },

  }
}
</script>
